import { Component, Prop, Emit } from 'vue-property-decorator';
import Vue from 'vue';
import { LabelSetting } from '../../i18n/locale-helper';
import { SAVE_ACTION } from '../../common/constants';
import { getDefaultSetting } from "../../utils/util";

@Component({
    render: function (createElement) {
        return this.template();
    },
    created() {
        const vm = this;
        if (vm.dialog) {
            vm.template = Vue.compile(require("./template.html")).render
        } else {
            vm.template = Vue.compile(require("./template-inline.html")).render
        }
    },
    // template: require('./template.html')
})
class ModalDialogComponent extends Vue {

    SAVE_ACTION = SAVE_ACTION;
    dtDefaultSettingWidth: string;
    @Prop({ default: true, type: [Boolean] }) dialog;
    @Prop({ default: true })
    hasId: boolean;
    @Prop({ default: true })
    showSave: boolean;
    @Prop({ default: false })
    showView: boolean;
    @Prop({ default: false })
    isLoading: boolean;

    @Prop({ default: 'Title', required: false })
    title: string;
    @Prop({ default: '' })
    icon: string;
    @Prop({ default: '' })
    width: string;
    @Prop({ default: false })
    loading: boolean;
    @Prop({ default: '8vh' })
    top: string;
    @Prop({ default: 'prefix' })
    actionPosition: string;
    @Prop({default: ''})
    customClass: string


    @Prop({ default: null, type: [String, Number] })
    itemId: string | number;
    @Prop({ default: null, type: [Object] })
    item: any;

    @Prop({ default: false })
    closeOnClickModal: boolean;
    @Prop({ default: false, required: true })
    visible: boolean;
    @Prop({ default: false })
    showSendMessage: boolean;
    @Prop({ default: false })
    showSaveAndClose: boolean;
    @Prop({ default: false })
    showPrintMessage: boolean;
    @Prop({ default: false })
    showSaveAndNew: boolean;
    @Prop({ default: false })
    closeOnPressEscape: boolean;
    @Prop({ default: true })
    appendToBody: boolean;
    @Prop({ default: null, type: [String] }) titleAppend;
    @Prop({ default: false, type: Boolean }) isConfirm;
    @Prop({ default: false, type: Boolean }) isFullScreen;
    @Prop({ default: false, type: Boolean }) isShowFullScreen;
    @Prop({ default: false, type: Boolean }) freezeWidth;
    @Prop({ default: true, type: Boolean }) showClose;

    get coShowSaveAndNew() {
        if (this.$route && this.$route.meta && this.$route.meta.hasOwnProperty('showSaveAndNew')) {
            return this.$route.meta.showSaveAndNew;
        } else {
            return this.showSaveAndNew;
        }
    }
    get coShowSaveAndClose() {
        if (this.$route && this.$route.meta && this.$route.meta.hasOwnProperty('showSaveAndClose')) {
            return this.$route.meta.showSaveAndClose;
        } else {
            return this.showSaveAndClose;
        }
    }
    get coShowSave() {
        if (this.$route && this.$route.meta && this.$route.meta.hasOwnProperty('showSave')) {
            return this.$route.meta.showSave;
        } else {
            return this.showSave
        }
    }
    get coShowFullScreen() {
        if (this.$route && this.$route.meta && this.$route.meta.hasOwnProperty('isShowFullScreen')) {
            return this.$route.meta.isShowFullScreen;
        } else {
            return this.isShowFullScreen
        }
    }
    get coShowView() {
        if (this.$route && this.$route.meta && this.$route.meta.hasOwnProperty('showView')) {
            return this.$route.meta.showView;
        } else {
            return this.showView
        }
    }
    get lblSetting() {
        return LabelSetting.Action;
    }
    get lblGlobal() { return LabelSetting.Global; }
    get lblAction() { return LabelSetting.Action; }
    get coWidthForConfirm() {
        let { widthInnerDialog } = getDefaultSetting();
        return widthInnerDialog;
    }
    get coWidth(): string {
        return this.width;
    }
    set coWidth(value: string) {
        this.$emit('update:width', value)
    }
    get coLoading(): boolean {
        return this.loading;
    }
    set coLoading(value: boolean) {
        this.$emit('update:loading', value)
    }
    get coActionPosition(): string {
        return this.actionPosition;
    }
    get coTop(): string {
        return this.top;
    }
    get coCloseOnClickModal() {
        return this.closeOnClickModal;
    }
    get coItemId() {
        return this.itemId;
    }
    get coTitle(): string {
        return this.title;
    }
    get coIcon(): string {
        return this.icon;
    }
    get coTitleAppend() { return this.titleAppend; }
    get coVisible(): boolean {
        return this.visible;
    }

    set coVisible(value: boolean) {
        this.$emit('update:visible', value);
    }
    get coIsConfirm(): boolean { return this.isConfirm; }
    set coIsConfirm(value: boolean) { this.$emit('update:isConfirm', value) }
    /**
     *
     */
    constructor() {
        super();
        this.dtDefaultSettingWidth = null;
        window.addEventListener("resize", this.handleResize);
    }

    mounted() {
        this.dtDefaultSettingWidth = this.width;
        // interact('.draggable')
        //     .draggable({
        // 	    onmove: (event) => {
        // 		    let target = event.target.parentNode.parentNode,
        // 			    x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx,
        // 			    y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;
        //
        // 		    target.style.webkitTransform =
        // 			    target.style.transform =
        // 				    'translate(' + x + 'px, ' + y + 'px)';
        //
        // 		    target.setAttribute('data-x', x);
        // 		    target.setAttribute('data-y', y);
        //         }
        //     })
    }

    handleSendMessage() {
        this.$emit("send-message");
    }

    handlePrintMessage() {
        this.$emit("print-message");
    }

    handleView() {
        this.$emit("view");
    }

    handleSave(action = SAVE_ACTION.CLOSE_AFTER_SAVE) {
        this.$emit("save", action);
    }

    @Emit('cancel')
    handleCancel() {
        this.coVisible = false;
    }

    @Emit('close')
    handleClose() {
        window.document.body.style.overflowY = 'hidden'
    }
    _setOverflowYHiddenCleanner: any;
    handleOpen() {

        clearTimeout(this._setOverflowYHiddenCleanner)
        this._setOverflowYHiddenCleanner = setTimeout(() => {
            this.handleResize();
            window.document.body.style.overflowY = 'hidden';
        }, 300);
        this.$emit('open')
    }
    handleResize() {
        if (this.freezeWidth) {
            this.dtDefaultSettingWidth = this.width;
            return;
        }
        if (!this.width) return;
        if (window.innerWidth <= 1200 && window.innerWidth >= 992) {
            this.dtDefaultSettingWidth = '85%';
        } else if (window.innerWidth < 992) {
            this.dtDefaultSettingWidth = '100%';
        }
        else if (window.innerWidth < 1600) {
            this.dtDefaultSettingWidth = parseFloat(this.coWidth) + 20 + '%';
        } else this.dtDefaultSettingWidth = this.coWidth;
    }

    @Emit('before-close')
    handleBeforeClose() {
    }

    handleConfirmWithNo() {
        this.coIsConfirm = false;
        this.$emit('close', {})
    }

    handleConfirmWithYes() {
        this.coIsConfirm = false;
        this.$emit('save', SAVE_ACTION.CLOSE_AFTER_SAVE)
    }

    beforeDestroy() {
        clearTimeout(this._setOverflowYHiddenCleanner);

        this.dtDefaultSettingWidth = null;
        window.removeEventListener("resize", this.handleResize);
        this._setOverflowYHiddenCleanner = null;
    }

    handleFullScreen(action: boolean = false) {
        this.isFullScreen = action;
    }

    handleOpened() {
        this.$emit('opened');
    }
}

export default ModalDialogComponent;